import React from "react"; 
import styled from "styled-components";    
import { MainOuterCard } from "../styles";
import { CustomLabel, FlexContainer, SapphireBlueButton } from "@mindmemobile/mm-shared-global";

type IProps = {
  icon: string;
  title: string;
  buttonCaption: string;
  buttonClick?: () => void;
  disableButton?: boolean;
};
interface IstyleProps {
  margin?: string;
}

export const PlhSmallerGridWrapper = styled.div<IstyleProps>`
  margin: ${(props) => props.margin || "20px 0px 0px"};
  .plh-label-icon {
    height: 22px;
    width: 22px;
  }
  ${MainOuterCard} {
    padding: 20px;
    border-radius: 10px;
  }
`;

const PlaceholderSmallerGrid: React.FC<IProps> = ({
  icon,
  title,
  buttonCaption,
  buttonClick,
  disableButton = true,
}) => {
  return (
    <PlhSmallerGridWrapper>
      <MainOuterCard padding="18px 25px">
        <FlexContainer justifyContent="space-between" alignItems="center">
          <div>
            <FlexContainer alignItems="center" spacing={18}>
              {" "}
              <img src={icon} className="plh-label-icon" alt="plh-label-icon" />
              <CustomLabel fontSize="20px" color="#2c3e50">
                {title}
                <span className="orange-semi-bold"></span>
              </CustomLabel>
            </FlexContainer>
          </div>
          <SapphireBlueButton
            minWidth="50px"
            // height="25px"  // 25 seems too small
            padding="4px 15px"
            disabled={disableButton}
            onClick={buttonClick}
            fontSize={'14px'}
          >
            {buttonCaption}
          </SapphireBlueButton>
        </FlexContainer>
      </MainOuterCard>
    </PlhSmallerGridWrapper>
  );
};

export default PlaceholderSmallerGrid;
